import axios from 'axios';
import AuthService from './auth-header';
import vertical from '@/navigation/vertical';
// /*dev*/const API_URL = 'https://ats.sattvahuman.in/api/';
// /*prod*/ // const API_URL = 'https://ats.sattvahuman.in/api/';

let API_URL = ''
    if (process.env.NODE_ENV === "production") {
        API_URL = 'https://ats.sattvahuman.in/api/'
    } else {
        API_URL = 'http://192.168.0.30:5000/api/'
    }

/** Let axios set multipart boundary; manual Content-Type breaks FormData parsing. */
function multipartAuthHeaders() {
    const headers = AuthService.authHeaderForm()
    delete headers['Content-Type']
    return headers
}

function candidateRequestHeaders(data) {
    if (typeof FormData !== 'undefined' && data instanceof FormData) {
        return multipartAuthHeaders()
    }
    return AuthService.authHeader()
}

class CandidateService {
    async addCandidate(data) {
        try {
            const res = await axios.post(API_URL + 'addCandidate', data,
                {
                    headers: AuthService.authHeaderForm()
                });
            console.log(res)
            return res.data
        }
        catch (err) {
            //console.log("error",err.response)
            //console.log(res)
            return err.response
        }
    }

    async getAllCandidates(id) {
        try {
            if (id !== 'null') {
                const res = await axios.get(API_URL + 'candidates?candidate_id=' + id,
                    {
                        headers: AuthService.authHeader()
                    });
                return res.data
            } else {
                const res = await axios.get(API_URL + 'candidates',
                    {
                        headers: AuthService.authHeader()
                    });
                return res.data
            }
            //console.log(res.data)  
        }
        catch (err) {
            console.log(err.response);
            return err.response
        }
    }
    async getAllCandidatesData() {
        try {

            const res = await axios.get(API_URL + 'all-candidates',
                {
                    headers: AuthService.authHeader()
                });
            //console.log(res.data)
            return res.data

            //console.log(res.data)  
        }
        catch (err) {
            console.log(err.response);
            return err.response
        }
    }
    async getSimpleFilteredCandidates(query) {
        try {

            const res = await axios.get(API_URL + 'candidates/search/?query=' + query,
                {
                    headers: AuthService.authHeader()
                });
            //console.log(res.data)
            return res.data

            //console.log(res.data)  
        }
        catch (err) {
            console.log(err.response);
            return err.response
        }
    }

    async updateCandidate(id, data) {
        try {
            const res = await axios.put(API_URL + 'candidates/' + id, data,
                {
                    headers: candidateRequestHeaders(data)
                });
            //console.log(res.data)
            return res.data
        }
        catch (err) {
            console.warn('updateCandidate failed', err && err.response && err.response.status);
            return err.response
        }
    }
    // Resume-only PUT: FormData with cvFile + updated_by (no empty numerics).
    // Do not force Content-Type — axios must set multipart boundary.
    async uploadCandidateResume(id, data) {
        try {
            const res = await axios.put(API_URL + 'candidates/' + id, data,
                {
                    headers: multipartAuthHeaders()
                });
            return res.data
        }
        catch (err) {
            console.warn('uploadCandidateResume failed', err && err.response && err.response.status);
            return err && err.response
                ? err.response
                : { status: 0, data: { message: 'Resume upload failed. Please try again.' } }
        }
    }
    async updateCandidateViewed(id, data) {
        try {
            const res = await axios.put(API_URL + 'candidates/viewed/' + id, data,
                {
                    headers: AuthService.authHeader()
                });
            //console.log(res.data)
            return res.data
        }
        catch (err) {
            console.log(err.response);
            return err.response
        }
    }

    async updateCandidateStatus(cid, jid, data) {
        try {
            console.log(data)
            const res = await axios.put(API_URL + 'candidates/status/' + cid + '/' + jid, data,
                {
                    headers: AuthService.authHeader()
                });
            //console.log(res.data)
            return res.data
        }
        catch (err) {
            console.log(err.response);
            return err.response
        }
    }

    async deleteCandidate(id) {
        try {
            const res = await axios.delete(API_URL + 'candidates/' + id,
                {
                    headers: AuthService.authHeader()
                });
            //console.log(res.data)
            return res.data
        }
        catch (err) {
            console.log(err.response);
            return err.response
        }
    }

    async getMatchingCandidates(data) {
        try {
            const params = "?query=" + data.query + "&skill=" + data.skill + "&source=" + data.source + "&qualification=" + data.qualification + "&location=" + data.location + "&exclude=" + data.exclude + "&gender=" + data.gender + "&minctc=" + data.minctc + "&maxctc=" + data.maxctc + "&minexp=" + data.minexp + "&maxexp=" + data.maxexp + "&minnp=" + data.minnp + "&maxnp=" + data.maxnp + "&status=" + data.status
            const res = await axios.get(API_URL + 'candidates/advancedSearch/' + params,
                {
                    headers: AuthService.authHeader()
                });
            //console.log(res)
            return res.data
        }
        catch (err) {
            console.log(err.response)
            return err.response
        }
    }
    async removeCandidateFromJob(id, jobid) {
        try {
            const res = await axios.get(API_URL + 'candidate/jobs/' + id + '/' + jobid,
                {
                    headers: AuthService.authHeader()
                });
            //console.log(res)
            return res.data
        }
        catch (err) {
            console.log(err.response)
            return err.response
        }
    }
    async getCandidateCurrentStatus(id, jobid) {
        try {
            //console.log(id, jobid)
            const res = await axios.get(API_URL + 'candidate/status/' + id + '/' + jobid,
                {
                    headers: AuthService.authHeader()
                });
            //console.log(res)
            return res.data
        }
        catch (err) {
            console.log(err.response)
            return err.response
        }
    }
    // async getMyCandidates(ids,data, startDate, endDate, revenue, cid, jid, dateField, jobStatus, client, jobType, payroll, mgr, category, vertical) {
    //     try{
    //         //console.log(ids, data)
    //         const res = await axios.get(API_URL + 'my-candidates?rec_ids=' + ids + '&role=' + data.role + '&rec=' + data.rec + '&status=' + data.status + '&sd=' + startDate + '&ed=' + endDate + '&revenue=' + revenue + '&cid=' + cid + '&jid=' + jid + '&dateField=' + dateField + '&jobStatus=' + jobStatus + '&client=' + client + '&jobType=' + jobType + '&payroll=' + payroll + '&mgr=' + mgr + '&category=' + category + '&vertical=' + vertical,
    //         { 
    //             headers: AuthService.authHeader()
    //         });
    //         //console.log(res)
    //         return res.data
    //     }
    //     catch(err) {
    //         console.log(err.response)
    //         return err.response
    //     }
    // }
    async getMyCandidates(ids, params) {
        try {
            console.log('params', params, ids)
            // Convert comma-separated ids to pipe-separated
            let formattedIds = ids;
            if (Array.isArray(ids)) {
                formattedIds = ids.join('|');
            } else {
                formattedIds = ids;
            }
            // const formattedIds = ids.replace(/,/g, '|');

            // Map parameters to API expected format
            const apiParams = {
                rec_ids: formattedIds,
                page: params.page,
                limit: params.limit,
                role: params.role,
                rec: params.rec,
                emp_id: params.emp_id,
                status: params.status,
                sd: params.startDate,        // renamed
                ed: params.endDate,          // renamed
                revenue: params.revenueSelected,
                cid: params.cid,
                jid: params.jid,
                dateField: params.dateField,
                jobStatus: params.jobStatus,
                client: params.client,
                jobType: params.jobType,
                payroll: params.payroll,
                mgr: params.mgr,
                category: params.category,
                vertical: params.vertical,
                filter: params.filter,
                download: params.download,
                business: params.business,
                subBusiness: params.subBusiness
            };

            console.log('apiParams', apiParams)

            const res = await axios.get(API_URL + 'my-candidates', {
                params: apiParams,
                headers: AuthService.authHeader()
            });
            console.log('my candidates res from service: ', res.data);
            return res.data;
        } catch (err) {
            console.log(err);
            return err.response;
        }
    }

    async getKPMGRPOCandidates(params) {
        try {
            console.log('KPMG RPO candidates params:', params)

            // Map parameters to API expected format for KPMG RPO endpoint
            const apiParams = {
                page: params.page || 1,
                limit: params.limit || 100,
                business: params.business || null,
                sub_business: params.subBusiness || null,
                status: params.status || null,
                poc: params.poc || null,
                emp_id: params.emp_id || null,
                filter: params.filter || null
            };

            console.log('KPMG RPO apiParams:', apiParams)

            const res = await axios.get(API_URL + 'kpmg-rpo-candidates', {
                params: apiParams,
                headers: AuthService.authHeader()
            });
            console.log('KPMG RPO candidates res from service: ', res.data);
            return res.data;
        } catch (err) {
            console.log('KPMG RPO candidates error:', err);
            return err.response;
        }
    }
    async getRelianceRPOCandidates(params) {
        try {
            // console.log('Reliance RPO candidates params:', params)

            // Map parameters to API expected format for Reliance RPO endpoint
            const apiParams = {
                page: params.page || 1,
                limit: params.limit || 100,
                status: params.status || null,
                filter: params.filter || null
            };

            // console.log('Reliance RPO apiParams:', apiParams)

            const res = await axios.get(API_URL + 'reliance-rpo-candidates', {
                params: apiParams,
                headers: AuthService.authHeader()
            });
            // console.log('Reliance RPO candidates res from service: ', res.data);
            return res.data;
        } catch (err) {
            // console.log('Reliance RPO candidates error:', err);
            return err.response;
        }
    }
    
    async getCandidateViewData(id) {
        try {
            //console.log(id)
            const res = await axios.get(API_URL + 'candidates/view?candidate_id=' + id,
                {
                    headers: AuthService.authHeader()
                });
            //console.log(res)
            return res.data
        }
        catch (err) {
            console.log(err.response)
            return err.response
        }
    }

    /**
     * Fetch candidate view payloads for unique IDs with a small concurrency cap.
     * Skips empty IDs. Callers should already exclude session-cached entries.
     */
    async getCandidatesByIds(ids, options = {}) {
        const unique = []
        const seen = new Set()
        ;(Array.isArray(ids) ? ids : []).forEach(id => {
            if (id == null || id === '') return
            const key = String(id)
            if (seen.has(key)) return
            seen.add(key)
            unique.push(id)
        })
        if (!unique.length) return {}

        const concurrency = Math.max(1, Math.min(Number(options.concurrency) || 4, 6))
        const shouldAbort = typeof options.shouldAbort === 'function' ? options.shouldAbort : null
        const onEach = typeof options.onEach === 'function' ? options.onEach : null
        const results = {}
        let cursor = 0

        const worker = async () => {
            while (cursor < unique.length) {
                if (shouldAbort && shouldAbort()) return
                const id = unique[cursor]
                cursor += 1
                const res = await this.getCandidateViewData(id)
                results[id] = res
                if (onEach) onEach(id, res)
            }
        }

        const workers = []
        for (let i = 0; i < Math.min(concurrency, unique.length); i += 1) {
            workers.push(worker())
        }
        await Promise.all(workers)
        return results
    }
    async getCandidateJoinedListReadyForInvoice(client, category) {
        try {
            //console.log(client, category)
            const res = await axios.get(API_URL + 'candidates/list/invoice?client=' + client + '&category=' + category,
                {
                    headers: AuthService.authHeader()
                });
            console.log(res)
            return res.data
        }
        catch (err) {
            console.log(err.response)
            return err.response
        }
    }
    async checkCandidateExist(email, contact_no) {
        try {

            const res = await axios.get(API_URL + 'candidate/exist?email=' + email + '&contact_no=' + contact_no,
                {
                    headers: AuthService.authHeader()
                });
            console.log(res)
            return res.data
        }
        catch (err) {
            console.log(err.response)
            return err.response
        }
    }
    async uploadInfraCanAadhaar(data) {
        try {
            const res = await axios.post(API_URL + 'candidates/infra/docs/aadhaar', data,
                {
                    headers: AuthService.authHeaderForm()
                });
            console.log(res)
            return res
        }
        catch (err) {
            console.log("error", err.response)
            //console.log(res)
            return err.response
        }
    }
    async uploadInfraCanPan(data) {
        try {
            const res = await axios.post(API_URL + 'candidates/infra/docs/pan', data,
                {
                    headers: AuthService.authHeaderForm()
                });
            console.log(res)
            return res
        }
        catch (err) {
            console.log("error", err.response)
            //console.log(res)
            return err.response
        }
    }
    async uploadInfraCanCertificate(data) {
        try {
            const res = await axios.post(API_URL + 'candidates/infra/docs/certificate', data,
                {
                    headers: AuthService.authHeaderForm()
                });
            console.log(res)
            return res
        }
        catch (err) {
            console.log("error", err.response)
            //console.log(res)
            return err.response
        }
    }
    async uploadInfraCanPhoto(data) {
        try {
            const res = await axios.post(API_URL + 'candidates/infra/docs/photo', data,
                {
                    headers: AuthService.authHeaderForm()
                });
            console.log(res)
            return res
        }
        catch (err) {
            console.log("error", err.response)
            //console.log(res)
            return err.response
        }
    }
    async uploadInfraCanBank(data) {
        try {
            const res = await axios.post(API_URL + 'candidates/infra/docs/bank', data,
                {
                    headers: AuthService.authHeaderForm()
                });
            console.log(res)
            return res
        }
        catch (err) {
            console.log("error", err.response)
            //console.log(res)
            return err.response
        }
    }
    /**
     * Best-effort delete of a previous infra KYC object after a successful reupload.
     * Backend should prefer deleting inside the upload handlers when `replace`/`oldFile` are sent;
     * this endpoint is a fallback for orphan cleanup. Safe to 404 until implemented.
     * Body: { id, documentType, oldFile }
     */
    async deleteInfraCanDocument(data) {
        try {
            const res = await axios.delete(API_URL + 'candidates/infra/docs', {
                headers: AuthService.authHeader(),
                data,
            });
            return res
        }
        catch (err) {
            return err && err.response ? err.response : null
        }
    }
    async getCandidateDocuments(id) {
        try {
            //console.log(id)
            const res = await axios.get(API_URL + 'candidates/infra/documents/' + id,
                {
                    headers: AuthService.authHeader()
                });
            //console.log(res)
            return res
        }
        catch (err) {
            console.log(err.response)
            return err.response
        }
    }
    async checkCandidateExistWithMetadata(data) {
        try {

            const res = await axios.get(API_URL + 'candidate/exist/metadata/' + data.panNumber + '/' + data.aadhaarNumber,
                {
                    headers: AuthService.authHeader()
                });
            console.log(res)
            return res
        }
        catch (err) {
            console.log(err.response)
            return err.response
        }
    }
    // async submitToPayrollApproval(formData) {
    //     try{
    //         const res = await axios.post(API_URL + 'candidates/payroll/approval', formData,
    //         { 
    //             headers: AuthService.authHeaderForm()
    //         });
    //         console.log(res)
    //         return res.data
    //     }
    //     catch(err) {
    //         console.log(err.response)
    //         return err.response
    //     }
    // }
    async submitToPayrollApproval(formData) {
        try {
            const res = await axios.post(API_URL + 'candidates/payroll/approval', formData,
                {
                    headers: AuthService.authHeaderForm()
                });
            console.log(res)
            return res.data
        }
        catch (err) {
            console.log(err.response)
            return err.response
        }
    }
    async submitToPayroll(formData) {
        try {
            const res = await axios.post(API_URL + 'candidates/payroll/submit', formData,
                {
                    headers: AuthService.authHeaderForm()
                });
            console.log(res)
            return res.data
        }
        catch (err) {
            console.log(err.response)
            return err.response
        }
    }
    async getIntellismartCandidates(params) {
        try {
            console.log('Intellismart candidates params:', params)

            // Check authentication first
            const authHeaders = AuthService.authHeader()
            console.log('Auth headers being sent:', authHeaders)

            // Check if we have a valid token
            const accessToken = localStorage.getItem('accessToken')
            const userData = localStorage.getItem('userData')
            console.log('Access token exists:', !!accessToken)
            console.log('User data exists:', !!userData)

            if (!accessToken) {
                console.error('No access token found in localStorage')
                return {
                    status: 'ERROR',
                    message: 'No authentication token found. Please login again.',
                    data: { candidates: [], statusWise: [], pagination: { totalRecords: 0 } }
                }
            }

            // Map parameters to API expected format for Intellismart endpoint
            const apiParams = {
                page: params.page || 1,
                limit: params.limit || 1000, // Increased limit to get all candidates
                status: params.status && params.status.length > 0 ? params.status : null,
                assignedTo: params.assignedTo || null,
                search: params.search || null,
                _t: Date.now() // Add timestamp to prevent caching
            };

            console.log('Intellismart apiParams:', apiParams)
            console.log('Making API call to: ${API_URL}intellismart-candidates')

            const res = await axios.get(`${API_URL}intellismart-candidates`, {
                params: apiParams,
                headers: authHeaders
            });
            console.log('Intellismart candidates res from service: ', res.data);
            return res.data;
        } catch (err) {
            console.error('Intellismart candidates error:', err)
            console.error('Error response:', err.response)
            console.error('Error status:', err.response?.status)
            console.error('Error data:', err.response?.data)

            // Return a proper error response structure
            return {
                status: 'ERROR',
                message: err.response?.data?.message || err.message || 'Failed to fetch candidates',
                error: {
                    status: err.response?.status,
                    statusText: err.response?.statusText,
                    data: err.response?.data
                },
                data: {
                    candidates: [],
                    statusWise: [],
                    pagination: { totalRecords: 0 }
                }
            }
        }
    }

    async getClientDashboardCandidates(params) {
        try {
            console.log('Client dashboard candidates params:', params)

            // Check authentication first
            const authHeaders = AuthService.authHeader()
            console.log('Auth headers being sent:', authHeaders)

            // Check if we have a valid token
            const accessToken = localStorage.getItem('accessToken')
            const userData = localStorage.getItem('userData')
            console.log('Access token exists:', !!accessToken)
            console.log('User data exists:', !!userData)
            const client = params.client

            console.log('Client:', client)
            if (!client) {  
                console.error('Client not found in params')
                return {
                    status: 'ERROR',
                    message: 'Client not found in params',
                    data: { candidates: [], statusWise: [], pagination: { totalRecords: 0 } }
                }
            }
            // const client = requestAnimationFrame.

            if (!accessToken) {
                console.error('No access token found in localStorage')
                return {
                    status: 'ERROR',
                    message: 'No authentication token found. Please login again.',
                    data: { candidates: [], statusWise: [], pagination: { totalRecords: 0 } }
                }
            }

            // Map parameters to API expected format for Intellismart endpoint
            const apiParams = {
                page: params.page || 1,
                limit: params.limit || 1000, // Increased limit to get all candidates
                status: params.status && params.status.length > 0 ? params.status : null,
                assignedTo: params.assignedTo || null,
                search: params.search || null,
                // client: params.client || null,
                _t: Date.now() // Add timestamp to prevent caching
            };

            console.log('Contractual apiParams:', apiParams)
            console.log('Making API call to: ${API_URL}dashboard/client/${params.client}')

            const res = await axios.get(`${API_URL}dashboard/client/${params.client}`, {
                params: apiParams,
                headers: authHeaders
            });
            console.log('Contractual candidates res from service: ', res.data);
            return res.data;
        } catch (err) {
            console.error('Contractual candidates error:', err)
            console.error('Error response:', err.response)
            console.error('Error status:', err.response?.status)
            console.error('Error data:', err.response?.data)

            // Return a proper error response structure
            return {
                status: 'ERROR',
                message: err.response?.data?.message || err.message || 'Failed to fetch candidates',
                error: {
                    status: err.response?.status,
                    statusText: err.response?.statusText,
                    data: err.response?.data
                },
                data: {
                    candidates: [],
                    statusWise: [],
                    pagination: { totalRecords: 0 }
                }
            }
        }
    }

    // async getPayrollApprovalStatus(candidateId) {
    //     try{
    //         const res = await axios.get(API_URL + 'candidates/payroll/approval-status/' + candidateId,
    //         { 
    //             headers: AuthService.authHeader()
    //         });
    //         console.log(res)
    //         return res.data
    //     }
    //     catch(err) {
    //         console.log(err.response)
    //         return err.response
    //     }
    // }

    //candidates/infra/documents/:id
}
export default new CandidateService();